import { GetterTree } from 'vuex';
import { State } from '@/store/modules/mobile/kpis/kpis.store';

const getters: GetterTree<State, State> = {
  getCurrentEventMessage: state => {
    return state.currentEventMessage;
  },
  getCurrentCrashID: state => {
    return state.currentCrashID;
  },
  getCurrentPerformanceID: state => {
    return state.currentPerformanceID;
  },
  getCurrentLocationDetails: state => {
    return {
      countryCode: state.currCountryCode,
      countryName: state.currCountryName
    };
  },
  getCurrentHttpReq: state => {
    return state.currentHttpReqName;
  },
  getCurrentPerfErrEventID: state => {
    return state.currPerfErrEventID;
  }
};
export default getters;
